import getScrollContainer from './getScrollContainer';
import { EditorViewState } from 'owa-editor';

/**
 * Used when the content size where compose is hosted is changed
 * Most likely a compensate scroll is needed to ensure compose is in reasonable position in the scroll region
 * delta: the amount of size increased or decreased. 0 indicates no change.
 * sourceElement: the source of change. Also the field of interest that needs to be brought to view port
 * if there is no need to bring a source Element to view port, caller should pass in a null
 */
export default function onContentSizeChanged(
    viewState: EditorViewState,
    delta: number,
    sourceElement: HTMLElement = null
) {
    const scrollContainer = getScrollContainer(viewState);

    if (!scrollContainer || delta == 0) {
        // scrollContainer is null, or there isn't really change
        return;
    }

    // Start with a min scrollTop of 0, and max allowed scroll top
    let minScrollTop = 0;
    let maxScrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;

    // Calcuate the scroll top that is needed to keep compose in its original position
    let newScrollTop = scrollContainer.scrollTop + delta;
    newScrollTop = Math.max(minScrollTop, newScrollTop);
    newScrollTop = Math.min(newScrollTop, maxScrollTop);

    // sourceElement is not only the source where the content size is changed, but also
    // the field of interest which we need to ensure it is brought to view port
    // calculate the min & max scroll top required to bring source element to view port
    if (sourceElement) {
        minScrollTop = Math.max(
            minScrollTop,
            sourceElement.offsetTop + sourceElement.clientHeight - scrollContainer.clientHeight
        );
        maxScrollTop = Math.min(maxScrollTop, sourceElement.offsetTop);
    }

    // Now check if newScrollTop can fall in the scope and use it if so
    // Otherwise scroll to make sure sourceElemen is brought to view port
    if (
        newScrollTop != scrollContainer.scrollTop &&
        newScrollTop >= minScrollTop &&
        newScrollTop <= maxScrollTop
    ) {
        scrollContainer.scrollTop = newScrollTop;
    } else {
        // When a scroll down is needed, pick the minScrollTop
        // Otherwise (scroll up), pick the maxScrollTop
        const originalScrollTop = scrollContainer.scrollTop;
        if (originalScrollTop < minScrollTop) {
            scrollContainer.scrollTop = minScrollTop;
        } else if (originalScrollTop > maxScrollTop) {
            scrollContainer.scrollTop = maxScrollTop;
        }
    }
}
